import { useEffect, useState } from "react";
import LoadingSpinner from "../LoadingSpinner";
import ModalGeneric from "./ModalGeneric";

// modal to show that user needs to install metamask
export default function ModalLoading({title, absolute, callback}) {
	return (
        <ModalGeneric title={title || 'Loading'} callback={callback} className='w-48 text-gray-400' absolute={absolute}>
            <LoadingSpinner className='w-20 m-auto mt-4 text-black' />
        </ModalGeneric>
	);
}
